import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { SensorActivationStatusResponse } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  uniqueId: string
  options?: Omit<UseMutationOptions<SensorActivationStatusResponse, Error, void>, 'mutationKey' | 'mutationFn'>
}

export const useSensorActivationStatusRequest = ({ uniqueId, options }: RequestParams) => {
  const api = useApiInstance()

  return useMutation<SensorActivationStatusResponse, Error, void>(
    [Entities.Sensors, 'activation-status', uniqueId],
    async () => {
      const { data } = await api.v1AdminSensorsUniqueIdActivationStatusGet(uniqueId)
      return data as SensorActivationStatusResponse
    },
    {
      ...options
    }
  )
}
